import styled from "styled-components";


export const ReservationTabsContainer = styled.div`
    width: 100%;
    margin-top: 20px;
    color: var(--font-color-blackalpha87);
    border-radius: 10px;
    box-shadow: 0px 14px 60px 0px rgba(22, 16, 59, 0.05);
    -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    -webkit-transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`

export const ReservationTabItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${props => props.active ? '#FFFFFF' : '#2555ef'};
  font-size: var(--general-tab-font-size);
  text-transform: none;
  path {
    fill: ${props => props.active ? '#FFFFFF' : '#2555ef'};
  }

  ${props => props.disabled && `
    opacity: 0.5;
  `}
`

export const ReservationTabItemText = styled.div`

  ${props => props.disabled && `
    opacity: 0.5;
  `}
`